import { Model } from './model';
import { Project } from './project';
import { PObject } from './object';

/*export enum WidgetStatus {
 Published,
 Draft,
 Archived
 }*/

/*type MyStringEnum = "member1" | "member2";

 const MyStringEnum = {
 Member1: "member1" as MyStringEnum,
 Member2: "member2" as MyStringEnum
 };*/

export type WidgetStatus = "Published" | "Draft" | "Archived";

export const WidgetStatus = {
  Published: "Published" as WidgetStatus,
  Draft: "Draft" as WidgetStatus,
  Archived: "Archived" as WidgetStatus
};


export interface WidgetTemplateConfiguration {
  sunstudies: boolean;
  maps: WidgetMapType[];
}

export class WidgetTemplateSetting {
  id: number;
  key: string;
  type: string;
  label: string;

  constructor(data?: any) {
    this.id = data.id;
    this.key = data.key;
    this.type = data.type;
    this.label = data.label;
  }
}

export class WidgetTemplateFilter {
  id: number;
  key: string;
  label: string;
  lighter: boolean;
  field: string;
  operator: string;
  value: string;

  constructor(data?: any) {
    this.id = data.id;
    this.key = data.key;
    this.label = data.label;
    this.lighter = data.lighter;
    this.field = data.field;
    this.operator = data.operator;
    this.value = data.value;
  }
}

export class WidgetTemplate extends Model {
  name: string;
  description: string;
  settings: WidgetTemplateSetting[];
  filters: WidgetTemplateFilter[];
  configuration: WidgetTemplateConfiguration;

  constructor(data?) {
    super(data);

    if (data) {
      this.name = data.config.name;
      this.description = data.description;

      this.settings = data.settings ? data.settings.data.map(s => {
        return new WidgetTemplateSetting(s);
      }) : null;

      this.filters = data.filters ? data.filters.data.map(s => {
        return new WidgetTemplateFilter(s);
      }) : null;

      if (data.config) {
        this.configuration = data.config;

        this.configuration.maps = data.config.maps.map(m => {
          return WidgetMapType[m];
        });
      }
    }
  }

  toJson() {
    return {};
  }
}

export interface RegionAttachable {
  getId(): number;

  text(): string;
}

export class WidgetMapRegion extends Model {
  entity: RegionAttachable;
  map: WidgetMap;
  points: { x: number, y: number }[] = [];
  tempId: number;

  constructor(data?) {
    super(data);
    if (data) {
      this.tempId = data.id;
      if (data.object) {
        this.entity = new PObject(data.object);
      }
      if (data.project) {
        this.entity = new Project(data.project);
      }
      if (data.map_link) {
        this.entity = new WidgetMap(data.map_link);
      }
      if (data.map) {
        this.map = new WidgetMap(data.map);
      }
      this.points = data.coords.map(c => {
        return {
          x: c.x,
          y: c.y
        };
      });
    }
  }

  toJson() {
    let data: any = {
      id: this.id,
      points: this.points,
      entity_id: this.entity.getId()
    };

    return data;
  }
}

export type WidgetMapType = "Objects" | "Maps" | "Projects";

export const WidgetMapType = {
  Objects: "Objects" as WidgetMapType,
  Maps: "Maps" as WidgetMapType,
  Projects: "Projects" as WidgetMapType
};

export class WidgetMap extends Model implements RegionAttachable {
  order: number;
  filename: string;
  imageUrl: string;
  name: string;
  mimetype: string;
  size: number;
  width: number;
  height: number;
  widget: Widget;
  project?: Project;
  regions: WidgetMapRegion[];
  type: WidgetMapType;
  sunstudy: WidgetSunstudy;
  fileId: string;

  constructor(data?: any) {
    super(data);
    if (data) {
      this.name = data.name;
      this.type = WidgetMapType[data.type];

      this.width = data.width;
      this.height = data.height;

      this.updatedAt = data.updated_at;
      this.createdAt = data.created_at;

      if (data.image) {
        this.filename = data.image.filename;
        this.mimetype = data.image.mimetype;
        this.order = data.image.order;
        this.size = data.image.size;
        this.width = data.image.width;
        this.height = data.image.height;
        this.imageUrl = data.image.url;
      }

      if (data.sunstudy) {
        this.sunstudy = new WidgetSunstudy(data.sunstudy);
      }

      if (data.regions) {
        this.regions = data.regions.data.map(r => {
          return new WidgetMapRegion(r);
        });
      }
      if (data.project) {
        this.project = new Project(data.project);
      }

      if (data.widget) {
        this.widget = new Widget(data.widget);
      }
    }
  }

  thumbnailUrl(): string {
    if (this.sunstudy) {
      return this.sunstudy.views.length
        ? this.sunstudy.views[0].firstImageUrl
        : null;
    }

    return this.imageUrl;
  }

  getId() {
    return this.id;
  }

  text() {
    return this.name;
  }

  toJson() {
    const data: any = {
      name: this.name,
      type: this.type,
      sunstudy_id: this.sunstudy ? this.sunstudy.id : null,
      file_id: this.sunstudy ? null : this.fileId,
      width: this.width,
      height: this.height,
      project_id: this.project && this.project.id ? this.project.id : null,
    };

    return data;
  }
}

function pad(pad, str, padLeft = null) {
  if (typeof str === 'undefined')
    return pad;
  if (padLeft) {
    return (pad + str).slice(-pad.length);
  } else {
    return (str + pad).substring(0, pad.length);
  }
}

export class WidgetSunstudyView extends Model {
  name: string;
  slug: string;
  baseUrl: string;
  imageCount: number;
  startFrame: number;
  startHour: number;
  endHour: number;
  images: string[];

  constructor(data?) {
    super(data);
    if (data) {
      const cacheBust = new Date().getTime();
      this.name = data.name;
      this.slug = data.slug;
      this.baseUrl = data.base_url;
      this.imageCount = data.image_count;
      this.startHour = data.start_hour;
      this.endHour = data.end_hour;
      this.startFrame = data.start_frame;
      this.images = data.images.data.map(img => {
        return img.url + '?nocache=' + cacheBust;
      });
    }
  }

  get firstImageUrl() {
    return `${this.baseUrl}/${pad('0000', this.startFrame, true)}.jpg`;
  }

  /*get images(): string[] {
    let images = [];
    const cacheBust = new Date().getTime();
    for (let i = 1; i < this.imageCount + 1; i++) {
      const url = pad('0000', i, true);
      images.push(`${this.baseUrl}/${url}.jpg`);
    }
    return images;
  }*/

  toJson() {
    return {
      name: this.name,
      starthour: this.startHour,
      endhour: this.endHour,
      startframe: this.startFrame
    };
  }
}

export interface WidgetInfo {
  mapCount: number;
  sunstudyCount: number;
}

export class WidgetSunstudy extends Model {
  name: string;
  url: string;
  views: WidgetSunstudyView[] = [];
  width: number;
  height: number;

  constructor(data?) {
    super(data);
    if (data) {
      this.name = data.name;
      this.url = data.url;
      this.width = data.width;
      this.height = data.height;
      if (data.views) {
        this.views = data.views.data.map(v => {
          return new WidgetSunstudyView(v);
        });
      }
    }
  }

  thumbnailUrl() {
    return this.views.length
      ? this.views[0].firstImageUrl
      : null;
  }

  toJson() {
    return {};
  }
}

export class WidgetFilter extends Model {
  filter: WidgetTemplateFilter;
  label: string;

  constructor(data?: any) {
    super(data);
    if (data) {
      this.filter = new WidgetTemplateFilter(data.filter);
      this.label = data.label;
    }
  }

  toJson(): any {
    return {
      id: this.filter.id,
      label: this.label
    }
  }
}

export class Widget extends Model {
  name: string;
  slug: string;
  //client: Client;
  info: WidgetInfo;
  project: Project;
  status: WidgetStatus;
  template: WidgetTemplate;
  maps: WidgetMap[];
  sunstudies: WidgetSunstudy[];
  previewUrl: string;
  thumbnailUrl: string;
  settings: { [key: string]: any } = {};
  filters: WidgetFilter[] = [];

  //settings: WidgetSetting[];

  constructor(data?) {
    super(data);
    if (data) {
      this.name = data.name;
      this.slug = data.slug;
      this.status = WidgetStatus[data.status];
      if (data.project) {
        this.project = new Project(data.project);
      }
      if (data.thumbnail_url) {
        this.thumbnailUrl = data.thumbnail_url;
      }
      this.template = new WidgetTemplate(data.template);
      this.maps = data.maps ? data.maps.data.map(function (map) {
        return new WidgetMap(map);
      }) : [];

      this.sunstudies = data.sunstudies ? data.sunstudies.data.map(function (study) {
        return new WidgetSunstudy(study);
      }) : [];

      this.previewUrl = data.preview_url;

      this.settings = data.settings ? data.settings : {};
      this.filters = data.filters ? data.filters.data.map(f => new WidgetFilter(f)) : [];

      if (data.info) {
        this.info = {
          mapCount: data.info.maps_count,
          sunstudyCount: data.info.sunstudies_count
        };
      }
    }
  }

  toJson() {
    return {
      project_id: this.project.id,
      status: this.status,
      template_id: this.template.id,
      name: this.name,
      slug: this.slug,
      settings: this.settings,
      filters: this.filters.map(f => {
        return {
          id: f.filter.id,
          label: f.label
        }
      })
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/models/widget.ts